module.exports = __webpack_public_path__ + "static/img/t1-4-2.f06e104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-4-2.png
// module id = Q2WB
// module chunks = 1